import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { shortAddress, shortName } from 'dibs-crypto-utils/exports/formattingUtils';

import styles from './styles/NftItemTileAuctionDetails.scss';
import { type NftItemTileAuctionDetailsFallback_nftItem$key } from './__generated__/NftItemTileAuctionDetailsFallback_nftItem.graphql';

type Props = {
    nftItem: NftItemTileAuctionDetailsFallback_nftItem$key;
    showOwner?: boolean;
};

export const NftItemTileAuctionDetailsFallback: FC<Props> = ({
    nftItem: nftItemRef,
    showOwner = true,
}) => {
    const nftItem = useFragment(
        graphql`
            fragment NftItemTileAuctionDetailsFallback_nftItem on NftItem {
                ownerAddress {
                    address
                    publicProfile {
                        profileName
                    }
                    ensDomain
                }
            }
        `,
        nftItemRef
    );

    const ownerAddress = nftItem.ownerAddress;

    return (
        <div className={styles.withPadding}>
            <div>
                <FormattedMessage
                    id="nft.RegularTileContent.noAuction"
                    defaultMessage="No Price Set"
                />
            </div>

            {showOwner && (
                <FormattedMessage
                    id="nftItemTile.auctionDetailsFallback.owner"
                    defaultMessage="{owner} Owner"
                    values={{
                        owner: (
                            <Link href={`/nft/address/ethereum/${ownerAddress?.address}`}>
                                {shortName(ownerAddress?.publicProfile?.profileName || '') ||
                                    shortName(ownerAddress?.ensDomain || '') ||
                                    shortAddress(ownerAddress?.address || '0')}
                            </Link>
                        ),
                    }}
                />
            )}
        </div>
    );
};
